<template>
  <div id="trader">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'trader'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/venue/trader/Trader.vue